var _defs, _path, _polygon, _polygon2, _path2, _path3, _path4, _rect, _path5, _polygon3, _polygon4, _polygon5, _polygon6, _path6, _polygon7, _polygon8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColorEt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 297.38 70.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #ba2027;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #211e1e;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M259.16,7.41c-15.4,0-27.89,12.48-27.89,27.89,0,6.65,2.33,12.76,6.22,17.55l-6.22,10.34,11.33-5.45c4.63,3.42,10.36,5.45,16.56,5.45,15.4,0,27.89-12.48,27.89-27.89s-12.49-27.89-27.89-27.89M262.92,44.13c-4.88,2.07-10.52-.21-12.59-5.09-2.07-4.88.21-10.52,5.09-12.59,4.89-2.07,10.52.21,12.59,5.09,2.07,4.88-.21,10.52-5.09,12.59"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "32.59 7.41 37.66 7.41 49.36 22.79 49.36 7.41 54.78 7.41 54.78 32.39 50.11 32.39 38.01 16.51 38.01 32.39 32.59 32.39 32.59 7.41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "64.95 12.48 57.35 12.48 57.35 7.41 78.04 7.41 78.04 12.48 70.44 12.48 70.44 32.39 64.95 32.39 64.95 12.48"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M102.86,7.41h11.42c3.18,0,5.64.89,7.28,2.53,1.39,1.39,2.14,3.36,2.14,5.71v.07c0,4.03-2.18,6.57-5.35,7.74l6.1,8.92h-6.42l-5.35-7.99h-4.32v7.99h-5.49V7.41ZM113.92,19.54c2.68,0,4.21-1.43,4.21-3.53v-.07c0-2.35-1.64-3.57-4.32-3.57h-5.46v7.17h5.57Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M127.01,7.41h10.21c5.96,0,9.56,3.53,9.56,8.63v.07c0,5.78-4.5,8.78-10.1,8.78h-4.18v7.49h-5.49V7.41ZM136.86,20c2.75,0,4.35-1.64,4.35-3.78v-.07c0-2.46-1.71-3.78-4.46-3.78h-4.25v7.64h4.35Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M149.2,7.41h11.42c3.18,0,5.64.89,7.28,2.53,1.39,1.39,2.14,3.36,2.14,5.71v.07c0,4.03-2.18,6.57-5.35,7.74l6.1,8.92h-6.42l-5.35-7.99h-4.32v7.99h-5.49V7.41ZM160.26,19.54c2.68,0,4.21-1.43,4.21-3.53v-.07c0-2.35-1.64-3.57-4.32-3.57h-5.46v7.17h5.57Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 173.59,
    y: 7.41,
    width: 5.49,
    height: 24.98
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M181.97,28.75l3.25-3.89c2.25,1.86,4.6,3.03,7.46,3.03,2.25,0,3.6-.89,3.6-2.35v-.07c0-1.39-.86-2.11-5.03-3.18-5.03-1.28-8.28-2.67-8.28-7.64v-.07c0-4.53,3.64-7.53,8.74-7.53,3.64,0,6.74,1.14,9.28,3.18l-2.85,4.14c-2.21-1.53-4.39-2.46-6.49-2.46s-3.21.96-3.21,2.18v.07c0,1.64,1.07,2.18,5.39,3.28,5.07,1.32,7.92,3.14,7.92,7.49v.07c0,4.96-3.78,7.74-9.17,7.74-3.78,0-7.6-1.32-10.6-4"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "204.87 7.41 223.89 7.41 223.89 12.3 210.33 12.3 210.33 17.36 223.89 17.36 223.89 22.25 210.33 22.25 210.33 27.5 223.89 27.5 223.89 32.39 204.87 32.39 204.87 7.41"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "80.6 7.41 99.62 7.41 99.62 12.3 86.06 12.3 86.06 17.36 99.62 17.36 99.62 22.25 86.06 22.25 86.06 27.5 99.62 27.5 99.62 32.39 80.6 32.39 80.6 7.41"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "10.33 7.41 29.35 7.41 29.35 12.3 15.79 12.3 15.79 17.36 29.35 17.36 29.35 22.25 15.79 22.25 15.79 27.5 29.35 27.5 29.35 32.39 10.33 32.39 10.33 7.41"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "157.35 41.38 149.2 41.38 149.2 39.77 167.25 39.77 167.25 41.38 159.09 41.38 159.09 63.18 157.35 63.18 157.35 41.38"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M174.26,39.61h1.67l10.9,23.57h-1.91l-2.98-6.55h-13.81l-2.98,6.55h-1.81l10.9-23.57ZM181.22,55.05l-6.15-13.54-6.19,13.54h12.34Z"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "189.77 39.78 191.51 39.78 191.51 61.57 205.25 61.57 205.25 63.18 189.77 63.18 189.77 39.78"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "223.89 39.78 221.27 39.78 209.38 50.79 209.38 39.78 207.64 39.78 207.64 63.18 209.38 63.18 209.38 52.16 221.27 63.18 223.89 63.18 211.27 51.47 223.89 39.78"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorEt);
export default __webpack_public_path__ + "static/media/Color ET.05a1e7dda0154870a5ecf101a3e588a0.svg";
export { ForwardRef as ReactComponent };